module.exports = __webpack_public_path__ + "img/logo-circle.b40b4e8.png";